import React from 'react';

import { IconProps, StyledPath, StyledStrokedGroup, StyledSvg } from '../iconCommons';

export const IconMoneyEgg = ({ color = 'currentColor', size = 'small', ...props }: IconProps) => (
    <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none" size={size} {...props}>
        <StyledStrokedGroup color={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
            <StyledPath
                d="M10.892 10.844C11.1084 11.1286 11.3903 11.3568 11.7138 11.5092C12.0373 11.6615 12.3927 11.7335 12.75 11.719C13.889 11.719 14.812 11.026 14.812 10.172C14.812 9.318 13.889 8.626 12.75 8.626C11.611 8.626 10.688 7.933 10.688 7.078C10.688 6.223 11.611 5.531 12.75 5.531C13.1072 5.51652 13.4627 5.5885 13.7862 5.74084C14.1097 5.89318 14.3916 6.12136 14.608 6.406"
                color="none"
            />
            <StyledPath d="M12.75 11.719V12.75" color="none" />
            <StyledPath d="M12.75 4.5V5.531" color="none" />
            <StyledPath d="M19.5 12.375C19.5 10.875 17.636 0.75 12.75 0.75C7.864 0.75 6 10.875 6 12.375" color="none" />
            <StyledPath
                d="M3.75 15.75C4.136 17.8554 5.24792 19.7589 6.89231 21.1292C8.5367 22.4996 10.6095 23.25 12.75 23.25C14.8905 23.25 16.9633 22.4996 18.6077 21.1292C20.2521 19.7589 21.364 17.8554 21.75 15.75H3.75Z"
                color="none"
            />
            <StyledPath d="M1.5 14.25L3.75 15.75" color="none" />
            <StyledPath d="M2.25 18L4.085 17.082" color="none" />
            <StyledPath d="M20.1909 19.4611L22.4999 21.0001" color="none" />
        </StyledStrokedGroup>
    </StyledSvg>
);
